import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-payment-error',
  templateUrl: './payment-error.component.html',
  styleUrls: ['./payment-error.component.css']
})
export class PaymentErrorComponent implements OnInit {
  @Input() errorMessage: string;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/payment-error/payment-error.component.ts